// Synthèse vocale découpée en phrases (évite les coupures de Chrome sur les textes longs)
let keepAlive = null;

const nettoyer = (texte) => (texte || '')
  .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu, '')
  .replace(/https?:\/\/\S+/g, 'lien')
  .replace(/[*_#`>|]/g, '')
  .replace(/«|»/g, '"')
  .replace(/([^.!?:;\s])\s*\n+\s*/g, '$1. ')
  .replace(/\s*\n+\s*/g, ' ')
  .replace(/\s{2,}/g, ' ')
  .trim();

const decouper = (texte, max = 200) => {
  const phrases = texte.match(/[^.!?…]+[.!?…]*/g) || [texte];
  const morceaux = [];
  let courant = '';
  phrases.forEach((p) => {
    let phrase = p.trim();
    while (phrase.length > max) {
      const coupe = Math.max(phrase.lastIndexOf(',', max), phrase.lastIndexOf(' ', max));
      const idx = coupe > 40 ? coupe + 1 : max;
      morceaux.push(phrase.slice(0, idx).trim());
      phrase = phrase.slice(idx).trim();
    }
    if ((courant + ' ' + phrase).trim().length > max) {
      if (courant) morceaux.push(courant);
      courant = phrase;
    } else {
      courant = (courant + ' ' + phrase).trim();
    }
  });
  if (courant) morceaux.push(courant);
  return morceaux.filter(Boolean);
};

const choisirVoix = () => {
  const gender = localStorage.getItem('assistantVoice') || 'femme';
  const frVoices = window.speechSynthesis.getVoices().filter((v) => v.lang.startsWith('fr'));
  const sel = gender === 'homme'
    ? frVoices.find((v) => /male|homme|thomas|nicolas|paul|henri/i.test(v.name) && !/female|femme/i.test(v.name))
    : frVoices.find((v) => /female|femme|amelie|amélie|marie|audrey|denise|google français/i.test(v.name));
  return sel || frVoices[0];
};

export const stopSpeaking = () => {
  if (keepAlive) { clearInterval(keepAlive); keepAlive = null; }
  if ('speechSynthesis' in window) window.speechSynthesis.cancel();
};

export const speak = (texte, onEnd = null) => {
  if (!('speechSynthesis' in window)) { if (onEnd) onEnd(); return; }
  stopSpeaking();
  const morceaux = decouper(nettoyer(texte));
  if (!morceaux.length) { if (onEnd) onEnd(); return; }
  const voix = choisirVoix();
  morceaux.forEach((m, i) => {
    const u = new SpeechSynthesisUtterance(m);
    u.lang = 'fr-FR';
    u.rate = 1.02;
    if (voix) u.voice = voix;
    if (i === morceaux.length - 1) {
      const fin = () => { stopSpeaking(); if (onEnd) onEnd(); };
      u.onend = fin;
      u.onerror = fin;
    }
    window.speechSynthesis.speak(u);
  });
  keepAlive = setInterval(() => {
    if (window.speechSynthesis.speaking) { window.speechSynthesis.pause(); window.speechSynthesis.resume(); }
  }, 10000);
};
